import React, { Component } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { delay } from "@formant/core/common/delay";
import { fork } from "@formant/core/common/fork";
import { IEvent } from "@formant/core/model/IEvent";
import { animate } from "@formant/ui/utils/animate";

import * as styles from "./EventDetails.scss";
import { InterventionRequestDetails } from "./InterventionRequestDetails";

export interface IEventDetailsProps {
    event?: IEvent;
    onClose: () => void;
}

@observer
export class EventDetails extends Component<IEventDetailsProps> {
    @observable
    private visible: boolean = false;
    private event?: IEvent;

    public render() {
        const { onClose } = this.props;

        fork(this.setVisible(!!this.props.event));

        this.event = this.props.event || this.event;
        const { event } = this;

        if (!event || event.type !== "intervention-request") {
            return false;
        }

        return (
            <div
                className={classnames(
                    styles["event-details"],
                    this.visible && styles.visible,
                )}
            >
                <InterventionRequestDetails event={event} onRespond={onClose} />
            </div>
        );
    }

    private async setVisible(visible: boolean) {
        if (visible === this.visible) {
            return;
        }
        await delay();
        this.visible = visible;
        if (!visible) {
            await animate();
            this.event = undefined;
        }
    }
}
